import classnames from 'classnames';
import React from 'react';

import { SidebarPosition } from '@core/types';
import Thumbnail from '../Thumbnail';
import { DragDataType } from '../Thumbnail/Thumbnail';

interface ThumbnailTrackedProps {
	dragData?: DragDataType;
	displaySetInstanceUID: string;
	className?: string | null;
	imageSrc?: string;
	imageAltText?: string;
	description: string;
	seriesNumber?: string | number;
	numInstances: number;
	onClick: () => void;
	onDoubleClick: () => void;
	onClickUntrack?: () => void;
	viewportIdentificator?: any[];
	isTracked?: boolean;
	messages?: any;
	isActive: boolean;
	loadingProgress?: number;
	orientation?: string;
	isSubSeries?: boolean;
	SubSeriesIndex?: number;
	collapsible?: boolean;
	collapsed?: boolean;
	onToggleCollapse?: (e: React.MouseEvent<HTMLButtonElement>) => void;
	seriesInstanceUID?: string;
	sidePosition: SidebarPosition;
}

const ThumbnailTracked: React.FC<ThumbnailTrackedProps> = ({
	displaySetInstanceUID,
	className = null,
	imageSrc,
	imageAltText,
	description,
	seriesNumber,
	numInstances,
	orientation,
	messages,
	dragData,
	onClick,
	onDoubleClick,
	// onClickUntrack,
	// viewportIdentificator,
	// isTracked,
	isActive,
	loadingProgress,
	...rest
}) => {
	// const trackedIcon = isTracked ? 'circled-checkmark' : 'dotted-circle';
	// const viewportIdentificatorLabel = viewportIdentificator.join(', ');
	// const renderViewportLabels = () => {
	// 	const MAX_LABELS_PER_COL = 3;
	// 	const shouldShowStack = viewportIdentificator.length > MAX_LABELS_PER_COL;
	// 	if (shouldShowStack) {
	// 		return (
	// 			<div>
	// 				<div>
	// 					{viewportIdentificator.slice(0, MAX_LABELS_PER_COL).map((label) => (
	// 						<div key={label}>{label}</div>
	// 					))}
	// 				</div>
	// 				<Tooltip
	// 					position="right"
	// 					content={
	// 						<div className="max-w-40 text-left">
	// 							Series is displayed <br /> in viewport {viewportIdentificatorLabel}
	// 						</div>
	// 					}
	// 				>
	// 					<Icon
	// 						name="tool-more-menu"
	// 						className="py-2 text-white"
	// 					/>
	// 				</Tooltip>
	// 			</div>
	// 		);
	// 	}

	// 	return viewportIdentificator.map((label) => <div key={label}>{label}</div>);
	// };

	const { isSubSeries = false, collapsed = false } = rest;

	return (
		<div
			className={classnames('flex w-24 cursor-pointer flex-row  outline-none', className, collapsed && isSubSeries ? 'hidden' : '')}
			id={`thumbnail-${displaySetInstanceUID}`}
		>
			{/* <div className="flex-2 flex flex-col items-center">
				<div
					className={classnames(
						'relative mb-2 flex cursor-pointer flex-col items-center justify-start p-2',
						isTracked && 'rounded-sm hover:bg-gray-900'
					)}
				>
					<Tooltip
						position="right"
						content={
							<div className="flex flex-1 flex-row">
								<div className="flex-2 flex items-center justify-center pr-4">
									<Icon
										name="info-link"
										className="text-primary-active"
									/>
								</div>
								<div className="flex flex-1 flex-col">
									<span>
										Series is
										<span className="text-white">{isTracked ? ' tracked' : ' untracked'}</span>
									</span>
									{!!viewportIdentificator.length && (
										<span>
											in viewport
											<span className="ml-1 text-white">{viewportIdentificatorLabel}</span>
										</span>
									)}
								</div>
							</div>
						}
					>
						<Icon
							name={trackedIcon}
							className="mb-2 w-4 text-primary-light"
						/>
					</Tooltip>

					<div
						className="text-center text-xl leading-tight text-white"
						data-cy={'thumbnail-viewport-labels'}
					>
						{renderViewportLabels()}
					</div>
				</div>
				{isTracked && (
					<div onClick={onClickUntrack}>
						<Icon
							name="cancel"
							className="w-4 text-primary-active"
						/>
					</div>
				)}
			</div> */}
			<Thumbnail
				displaySetInstanceUID={displaySetInstanceUID}
				imageSrc={imageSrc}
				imageAltText={imageAltText}
				dragData={dragData}
				description={description}
				seriesNumber={seriesNumber}
				messages={messages}
				numInstances={numInstances}
				orientation={orientation}
				isActive={isActive}
				onClick={onClick}
				onDoubleClick={onDoubleClick}
				loadingProgress={loadingProgress}
				{...rest}
			/>
		</div>
	);
};

export default ThumbnailTracked;
